import React from 'react'
import PropTypes from 'prop-types'
import ButterToast, { Cinnamon } from 'butter-toast'
import MEModal from '../../components/MEModal'
import { useStateValue } from '../../state'
import { client } from '../../utils'
import { notebook as endpoints } from '../../api_urls'

const DeleteHighlightModal = props => {
  let [currentState, dispatch] = useStateValue()

  const deleteHighlight = async hId => {
    let data = {
      ...currentState,
      hId: hId,
    }
    let resp = null
    try {
      resp = await client.post(endpoints.deleteHighlight(), data)
      dispatch({ type: 'updateHighlights', payload: resp.data.highlights })
    } catch (err) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Error"
            content={err.response.data.error}
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-thumbs-down fa-3x" />}
          />
        ),
        sticky: true,
      })
    }
    props.toggleModal()
  }

  return (
    <div>
      <MEModal show={props.show} close={props.close} title="Delete Highlight?">
        <p>Are you sure you want to delete this highlight?</p>
        <div className="mt-4 text-center">
          <button onClick={props.toggleModal} className="btn btn-default mr-3">
            Cancel
          </button>
          <button
            onClick={() => deleteHighlight(props.hId)}
            className="btn btn-danger mr-2"
          >
            Delete
          </button>
        </div>
      </MEModal>
    </div>
  )
}

DeleteHighlightModal.propTypes = {
  toggleModal: PropTypes.func,
  show: PropTypes.bool,
  close: PropTypes.func,
  hId: PropTypes.string,
}

export default DeleteHighlightModal
